import type { MessageContext } from "../conversation/message-context";
import {
  createVoiceEventId,
  SHOP_PAGE_CONTEXT_ACTION,
  type VoiceGatewayEvent,
} from "./protocol";

/** 异步结果只返回给发起请求的连接和启动代次。 */
export function answerClientAction(
  event: VoiceGatewayEvent,
  deps: {
    readContext: () => Promise<MessageContext>;
    send: (event: VoiceGatewayEvent) => boolean;
    isCurrent: () => boolean;
  },
): void {
  const requestId = event.event_id;
  if (typeof requestId !== "string" || requestId === "") return;
  const reply = (result: VoiceGatewayEvent) => {
    if (deps.isCurrent())
      deps.send({
        type: "client.action.result",
        event_id: createVoiceEventId(),
        request_event_id: requestId,
        ...result,
      });
  };
  if (event.name !== SHOP_PAGE_CONTEXT_ACTION) {
    reply({
      status: "unsupported",
      error: {
        code: "client_action_unsupported",
        message: "unsupported client action",
      },
    });
    return;
  }
  void deps.readContext().then(
    (context) => {
      reply({ status: "completed", output: context });
    },
    () => {
      reply({
        status: "failed",
        error: {
          code: "page_context_failed",
          message: "page context read failed",
        },
      });
    },
  );
}
